import { db } from './config';
import { doc, getDoc } from 'firebase/firestore';
import { auth } from './config';

const WORKER_BASE_URL = 'https://onyros-api.atelier-davai.workers.dev';

// Récupérer l'email de correspondance
export const getCorrespondenceEmail = async (): Promise<string | null> => {
  try {
    const settingsRef = doc(db, 'settings', 'email');
    const docSnap = await getDoc(settingsRef);
    
    if (docSnap.exists()) {
      return docSnap.data().correspondenceEmail;
    }
    return null;
  } catch (error) {
    console.error('Erreur lors de la récupération de l\'email de correspondance:', error);
    return null;
  }
};

// Valeurs par défaut de génération d'image si rien n'est configuré dans Firestore
export const DEFAULT_RUNWARE_MODEL = 'sourceful:2@2';
export const DEFAULT_IMAGE_WIDTH = 1152;
export const DEFAULT_IMAGE_HEIGHT = 2048;
export const DEFAULT_IMAGE_OUTPUT_QUALITY = 85;

export interface ImageGenerationSettings {
  model: string;
  width: number;
  height: number;
  outputQuality: number;
}

// Récupérer le modèle Runware + dimensions configurés depuis l'admin (settings/imageGeneration)
export const getImageGenerationSettings = async (): Promise<ImageGenerationSettings> => {
  const fallback: ImageGenerationSettings = {
    model: DEFAULT_RUNWARE_MODEL,
    width: DEFAULT_IMAGE_WIDTH,
    height: DEFAULT_IMAGE_HEIGHT,
    outputQuality: DEFAULT_IMAGE_OUTPUT_QUALITY,
  };
  try {
    const settingsRef = doc(db, 'settings', 'imageGeneration');
    const docSnap = await getDoc(settingsRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      const model = typeof data.runwareModel === 'string' && data.runwareModel.trim()
        ? data.runwareModel.trim() : fallback.model;
      const width = Number.isInteger(data.runwareWidth) && data.runwareWidth > 0
        ? data.runwareWidth : fallback.width;
      const height = Number.isInteger(data.runwareHeight) && data.runwareHeight > 0
        ? data.runwareHeight : fallback.height;
      const outputQuality = Number.isInteger(data.runwareOutputQuality) && data.runwareOutputQuality > 0
        ? data.runwareOutputQuality : fallback.outputQuality;
      return { model, width, height, outputQuality };
    }
    return fallback;
  } catch (error) {
    console.error('Erreur lors de la récupération des paramètres de génération d\'image:', error);
    return fallback;
  }
};

// Mettre à jour l'email de correspondance via le worker
export const updateCorrespondenceEmail = async (email: string): Promise<boolean> => {
  try {
    const idToken = await auth.currentUser?.getIdToken();
    if (!idToken) throw new Error('Utilisateur non authentifié');

    const response = await fetch(`${WORKER_BASE_URL}/api/settings/email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
      body: JSON.stringify({
        email,
        updatedAt: new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la mise à jour de l\'email');
    }

    const result = await response.json();
    return result.success;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de l\'email de correspondance:', error);
    return false;
  }
};
